import { render } from "./NTextWithLabel.vue?vue&type=template&id=857f22c8&ts=true"
import script from "./NTextWithLabel.vue?vue&type=script&lang=ts"
export * from "./NTextWithLabel.vue?vue&type=script&lang=ts"

import "./NTextWithLabel.vue?vue&type=style&index=0&id=857f22c8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__